@if (!showNewOrderPlacedContent) {
  <section id="oldOrderplacedBannerContent" class="tw-rounded-3 tw-mx-4 tw-px-2 tw-py-3 tw-border-[2px] tw-border-solid tw-border-teal-200 tw-max-h-18 tw-box-border"
    style="background: linear-gradient(95deg, #E4F4F0 -6.23%, #FFF 88%);"
    routerLink="/user/order/{{order?.objectId}}" (click)="handleClick()">
    <div class="header tw-flex tw-items-center">
      <div >
        <cs-icon class="tw-h-12 tw-w-12" [iconName]="'order_received'"></cs-icon>
      </div>
      <div class="tw-ml-2 tw-flex tw-flex-col tw-min-h-12 tw-gap-1">
        <div class="tw-flex tw-items-center">
          <div class="tw-leading-4 tw-font-body tw-font-bold tw-text-[14px] tw-items-center tw-flex tw-pt-1" i18n="@@orderReceivedTitle">
      Order Received
    </div>
          <cs-icon class="tw-pt-1 tw-h-5 tw-w-5 tw-pl-2" [iconName]="'chevron_right_teal'"></cs-icon>
        </div>
        <div class="tw-leading-[18px] tw-font-body tw-text-gray-500 tw-font-medium tw-text-[12px] tw-items-center tw-flex" i18n="@@orderReceived">We have received your order</div>
      </div>
    </div>
  </section>
}
@if (showNewOrderPlacedContent) {
  <section id="newOrderplacedBannerContent" class="tw-rounded-3 tw-mx-4 tw-px-2 tw-py-3 tw-border-[2px] tw-border-solid tw-border-teal-200 tw-box-border"
    style="background: linear-gradient(95deg, #E4F4F0 -6.23%, #FFF 88%);"
    routerLink="/user/order/{{order?.objectId}}" (click)="handleClick()">
    <div class="header tw-flex tw-items-center">
      <div>
        <cs-icon class="tw-h-12 tw-w-12" [iconName]="'order_received'"></cs-icon>
      </div>
      <div class="tw-ml-2 tw-flex tw-flex-col tw-min-h-12 tw-gap-1">
        <div class="tw-flex tw-items-center">
          <p class="tw-leading-4 tw-font-body tw-font-bold tw-text-[14px] tw-items-center tw-flex tw-pt-1" i18n="@@preparingYourOrder">Preparing your order</p>
          <cs-icon class="tw-pt-1 tw-h-5 tw-w-5 tw-pl-2" [iconName]="'chevron_right_teal'"></cs-icon>
        </div>
        <div class="tw-leading-[18px] tw-font-body tw-text-gray-500 tw-font-medium tw-text-[12px] tw-items-center tw-flex" i18n="@@yourOrderIsBeingPrepared">Your order is being prepared and will be dispatched soon</div>
      </div>
    </div>
  </section>
}
